import { ContactMaster, ContactDescription } from "./types";

export const CONTACT_MASTER: ContactMaster = {
    user_id: "",
    contact_id: "",
    name: "",
    person_profile: "",
    howyoumeet: "",
    howyoumeet_id: "",
    keepintouch: "Quarterly",
    original_person_id: "",
    shared_person: false,
    syncWithApple: false,
};

export const CONTACT_DESCRIPTION: ContactDescription = {
    contact_id: "",
    desc_id: "",
    birthdayDate: "",
    description: "",
    factKind: 0, // 0-context, 1-location, 2-kid, 3-birthday
    factNotif: true,
    kidAge: 0,
    kidBirthdayDate: "",
    kidName: "",
    kidOptionSelected: 0, // 0-son, 1-daughter, 2-unknown
    location: "",
    person_profile: "",
    locationLatLon: "",
    validLocation: false,
    inAdvanceFactNotif: true,
    inAdvanceFirstWord: "daily",
    inAdvanceSecondWord: "2",
    inAdvanceThirdWord: "weeks",
    remindOnDate: "",
    locationDistanceNotif: true,
    locationDistanceOption: 25,
};
